export const GET_ADDRESS_BY_CATEGORY_SUCCESS = 'GET_ADDRESS_BY_CATEGORY_SUCCESS';
export const GET_ADDRESS_BY_CATEGORY_REQUEST = 'GET_ADDRESS_BY_CATEGORY_REQUEST';
export const GET_ADDRESS_BY_CATEGORY_FAILURE = 'GET_ADDRESS_BY_CATEGORY_FAILURE';
export const GET_ADDRESS_BY_CATEGORY_RESET = 'GET_ADDRESS_BY_CATEGORY_RESET';
export const getAddressByCategorySuccess = (payload) => ({
    type: GET_ADDRESS_BY_CATEGORY_SUCCESS,
    payload,
});
export const getAddressByCategoryRequest = (payload) => ({
    type: GET_ADDRESS_BY_CATEGORY_REQUEST,
    payload,
});
export const getAddressByCategoryFailure = (payload) => ({
    type: GET_ADDRESS_BY_CATEGORY_FAILURE,
    payload,
});
export const getAddressByCategoryReset = () => ({
    type: GET_ADDRESS_BY_CATEGORY_RESET,
});
